/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Hier werden die Produkte in Form einzelner Karten angezeigt.
 * Pro Zeile werden mehrere Produktkarten angezeigt.
 * 
 * Wählt der Benutzer hier eine Produktkarte aus, so wird das 
 * vollständige Produkt mittels der Komponente ProdukctLandscape.js
 * oder ProduktPortrait.js angezeigt. 
 * 
 * Der ProductControllerUser ist verwand mit diesem ProductControllerAdmin.
 * Der ProductControllerUser wird im User-Modus angezeigt.  
 * Der ProductControllerAdmin wird im Admin-Modus angezeigt, nur hier kann 
 * auch die Reihenfolge der dargestellten Produkte verändert werden.
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";
import ProductDetails from "./ProductDetails";
import * as portfolioActions from "../../../store/actions/portfolioActions";
import { ImageLoader } from "../../partials/ImageLoader";


class ProductControllerUser extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.productList = [];
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, windowWidth, headerHeight, path, orientation, appModus } = this.props.app;

        const itemWidth = (orientation === 'landscape') ? windowWidth / 6.5 : windowWidth / 4.7;
        const itemHeight = itemWidth * 1.25;

        const dialog = utils.getDialogByPath(path);

        const node = utils.getTreePortfolio(dialog.portfolio + '/' + dialog.groups, true);
        if (node === null) return null;

        const sequence = utils.getSequence(dialog.portfolio + '/' + dialog.groups);

        this.productList = [];
        if (sequence) {
            sequence.forEach((productName) => {
                const productFiltered = node.filter(f => f.name === productName);

                if (productFiltered.length > 0) this.productList.push(productFiltered[0]);
            })
        } else {
            node.forEach((d) => {
                this.productList.push(d);
            });
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderItem = (d, i) => {

            /**
             * Oberer Bereich 
             * Hier wird ein Bild der Produktgruppe angezeigt
             * Ist die Kachel breiter, so werden auch die ersten drei Unterverzeichnisse angezeigt
             */
            const renderIconFree = () => {
                const fileObj = utils.getFileInNode(d.children, 'free');
                if (!fileObj) return null;

                return (<ImageLoader path={fileObj.path} name={fileObj.name} height={'60%'} cover={'70%'} />)
            }

            const renderProperties = () => {

                const style = { height: '40%' };

                return (
                    <div className="w-full p-1 " style={style}>
                        <ProductDetails node={d} height={itemHeight * 0.11} version='center' />
                    </div>
                )
            }
            // ###############################################################
            // renderItem
            // ###############################################################
            const style = Object.assign({ width: itemWidth + 'px', backgroundColor: 'white' }, utils.getStyleHeight(itemHeight, 1.0, 1.0, 1));

            const onClick = () => {
                this.props.setPath(dialog.portfolio + '/' + dialog.groups + '/' + d.name);
                this.props.setCurrentProduct(d);
            }

            return (
                <div key={i} className="inline-block border-b-2 border-gray-400 " style={style} onClick={onClick}>
                    <div className=" h-full overflow-x-hidden mr-2 mt-1">
                        {renderIconFree()}
                        {renderProperties()}
                    </div>
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================        

        const style = {
            top: headerHeight + 'px',
            left: (orientation === 'landscape') ? '20%' : '25%',
            height: inputHeight + 'px',
            minHeight: inputHeight + 'px'
        };

        if (dialog.groups === '') return null; // wenn noch keine Gruppe ausgewählt wurde.

        if (dialog.product !== '') return null; // wenn eine Gruppe aber noch kein Produkt ausgewählt wurde. 

        if (appModus === 'Admin') return null;

        return (
            <div className="absolute h-full p-2 items-center bg-forsales-gray overflow-y-auto z-20" style={style}>
                {this.productList.map((d, i) => renderItem(d, i))}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductControllerUser);
